import { defineStyleConfig } from "@chakra-ui/react";

const BarChart = defineStyleConfig({
  baseStyle: () => {
    return {};
  },
});

export default BarChart;
